module.exports = __webpack_public_path__ + "img/SKWINKELNetActieCampagnematerialen5FA7C4.b5e91b8c.png";